export default __webpack_public_path__ + "static/media/account-cancel-outline.a60fcbe7.svg";